var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasData)?_c('div',{staticClass:"noDataDonut"},[_c('span',[_vm._v("No Data Available")])]):_c('apexchart',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.series,"height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }